
import type { PropType } from 'vue'
import type { FiltersMessages, RegularFilter } from '../../models'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { capitalizeSentence } from '../../filters/capitalize-sentence.filter'
import RegularFilterSelector from './regular-filter-selector.component.vue'

export default defineComponent({
  name: 'RegularFilterSelectorRounded',
  components: {
    RegularFilterSelector,
  },
  props: {
    filter: {
      type: Object as PropType<RegularFilter>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const filtersMessages = $epb.messages.filters as FiltersMessages

    const placeholder = computed(() => {
      const result = capitalizeSentence(
        props.filter.config.prettyName ??
          (filtersMessages.names[props.filter.config.id] as string) ??
          props.filter.config.id,
      )

      return props.filter.config.mandatory ? `${result} *` : result
    })

    return { placeholder }
  },
})
